import React, { useState, useEffect } from "react";
import { Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import { Public as GlobeIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

// Hjälpfunktion för att räkna ut UTC offset (bevarad logik)
const getUTCOffset = (timezone) => {
  try {
    const now = new Date();
    const utcString = now.toLocaleString("en-US", { timeZone: "UTC" });
    const tzString = now.toLocaleString("en-US", { timeZone: timezone });
    const diffMs = new Date(tzString) - new Date(utcString);
    const diffHours = diffMs / (1000 * 60 * 60);
    const sign = diffHours >= 0 ? "+" : "-";
    const absHours = Math.floor(Math.abs(diffHours));
    const absMinutes = Math.round((Math.abs(diffHours) % 1) * 60);

    return `UTC${sign}${absHours.toString().padStart(2, "0")}:${absMinutes
      .toString()
      .padStart(2, "0")}`;
  } catch (e) {
    return "UTC+00:00";
  }
};

const TimezoneSelect = ({ value, onChange, disabled }) => {
  const [timezones, setTimezones] = useState([]);
  const { t } = useTranslation("settings");

  useEffect(() => {
    if (typeof Intl.supportedValuesOf === "function") {
      // Vi sorterar dem alfabetiskt för enklare navigering
      const zones = Intl.supportedValuesOf("timeZone").sort();
      setTimezones(zones);
    } else {
      setTimezones([
        "UTC",
        "Europe/Stockholm",
        "America/New_York",
        "Asia/Singapore",
      ]);
    }
  }, []);

  return (
    <TextField
      select
      label={t("timezone")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      fullWidth // Timezone kan vara långa strängar, så fullWidth är bra här
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <GlobeIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            sx: {
              maxHeight: 300, // Begränsa höjden på dropdownen för bättre UX
              borderRadius: 2,
            },
          },
        },
      }}
    >
      {timezones.map((tz) => (
        <MenuItem key={tz} value={tz} sx={{ fontSize: "0.875rem" }}>
          {tz.replace("_", " ")}
          <Box
            component="span"
            sx={{
              ml: "auto",
              color: "text.secondary",
              pl: 2,
              fontSize: "0.75rem",
            }}
          >
            {getUTCOffset(tz)}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TimezoneSelect;
